import { render } from "./ProcessHeader.vue?vue&type=template&id=7af76515&scoped=true&ts=true"
import script from "./ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./ProcessHeader.vue?vue&type=script&lang=ts"

import "./ProcessHeader.vue?vue&type=style&index=0&id=7af76515&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af76515"]])

export default __exports__